/* Bagsandlove – Farbauswahl als Foto-Kacheln.
   Setzt beim Klick die passende Option im (versteckten) Variantenwähler des Themes,
   damit Preis, Galerie, URL, Warenkorb und Apps wie gewohnt aktualisiert werden. */
if (!customElements.get('bl-swatches')) {
  customElements.define(
    'bl-swatches',
    class BlSwatches extends HTMLElement {
      connectedCallback() {
        this.valueEl = this.querySelector('[data-bl-swatch-value]');
        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('.bl-swatch');
          if (swatch) this.select(swatch);
        });
        this.addEventListener('keydown', (event) => this.onKey(event));
        this.updateTabIndex();
        if (this.hasAttribute('data-multi')) this.watchThemePicker();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      get themePicker() {
        const scope = this.closest('product-info') || document;
        return scope.querySelector('variant-selects');
      }

      // Die Zeile im Variantenwähler des Themes, die zu dieser Option gehört (z. B. Farbe = 1. Zeile)
      themeGroup(picker) {
        const position = Number(this.dataset.optionPosition) || 1;
        return picker.querySelectorAll('.product-form__input')[position - 1] || picker;
      }

      // Mehrere Optionen (z. B. Farbe + Größe): Das Theme baut den Wähler nach jeder Auswahl neu auf.
      // Danach Kacheln abgleichen (gewählt / ausverkauft in dieser Größe) und die Größe in der Überschrift zeigen.
      watchThemePicker() {
        const scope = this.closest('product-info') || document.body;
        this.observer = new MutationObserver(() => {
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(() => this.syncFromTheme(), 0);
        });
        this.observer.observe(scope, { childList: true, subtree: true });
        this.syncFromTheme();
      }

      syncFromTheme() {
        const picker = this.themePicker;
        if (!picker) return;
        const group = this.themeGroup(picker);
        const inputs = [...group.querySelectorAll('input[type="radio"]')];
        const select = group.querySelector('select');
        const current = select ? select.value : inputs.find((input) => input.checked)?.value;
        this.swatches.forEach((swatch) => {
          const input = inputs.find((i) => i.value === swatch.dataset.value);
          const option = select && [...select.options].find((o) => o.value === swatch.dataset.value);
          const soldOut = input
            ? input.classList.contains('disabled') || input.classList.contains('visually-disabled')
            : Boolean(option && option.classList.contains('disabled'));
          swatch.classList.toggle('is-soldout', soldOut);
          if (current !== undefined) swatch.setAttribute('aria-checked', String(swatch.dataset.value === current));
        });
        const selected = this.swatches.find((s) => s.getAttribute('aria-checked') === 'true');
        if (selected && this.valueEl && this.valueEl.textContent !== selected.dataset.label) this.valueEl.textContent = selected.dataset.label;
        this.updateTabIndex();

        // Überschriften der übrigen Zeilen: „Größe" → „Größe: 40-41"
        picker.querySelectorAll('.product-form__input--pill').forEach((fieldset) => {
          if (fieldset === group) return;
          const legend = fieldset.querySelector('.form__label');
          const value = fieldset.querySelector('input[type="radio"]:checked')?.value;
          if (!legend || !value) return;
          let slot = legend.querySelector('[data-bl-value]');
          if (!slot) {
            legend.textContent = `${legend.textContent.trim().replace(/:$/, '')}: `;
            slot = document.createElement('span');
            slot.dataset.blValue = '';
            legend.append(slot);
          }
          if (slot.textContent !== value) slot.textContent = value;
        });
      }

      get swatches() {
        return [...this.querySelectorAll('.bl-swatch')];
      }

      select(swatch) {
        if (swatch.getAttribute('aria-checked') === 'true') return;
        this.swatches.forEach((s) => s.setAttribute('aria-checked', String(s === swatch)));
        this.updateTabIndex();
        if (this.valueEl) this.valueEl.textContent = swatch.dataset.label;
        this.holdScroll();
        this.applyToThemePicker(swatch.dataset.value);
      }

      // Nicht zur Galerie hochspringen – die gewählte Farbe sieht man in der Kachel.
      // Die Galerie des Themes ruft nach dem Farbwechsel window.scrollTo auf; das kurz unterdrücken.
      holdScroll() {
        if (!window.blOriginalScrollTo) window.blOriginalScrollTo = window.scrollTo.bind(window);
        clearTimeout(window.blScrollHold);
        window.scrollTo = () => {};
        window.blScrollHold = setTimeout(() => (window.scrollTo = window.blOriginalScrollTo), 1500);
      }

      applyToThemePicker(value) {
        const picker = this.themePicker;
        if (!picker) return;
        const name = `options[${this.dataset.optionName}]`;
        // Bei mehreren Optionen nur in der Farbzeile suchen, damit kein gleichnamiger Wert einer anderen Option greift
        const group = this.hasAttribute('data-multi') ? this.themeGroup(picker) : picker;

        const select = group.querySelector(`select[name="${CSS.escape(name)}"]`) || (group !== picker && group.querySelector('select'));
        if (select) {
          if (![...select.options].some((o) => o.value === value)) return;
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const radio = [...group.querySelectorAll('input[type="radio"]')].find((input) => input.value === value);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onKey(event) {
        const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const list = this.swatches;
        const current = list.findIndex((s) => s.getAttribute('aria-checked') === 'true');
        const dir = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        const next = list[(current + dir + list.length) % list.length];
        this.select(next);
        next.focus();
      }

      updateTabIndex() {
        this.swatches.forEach((s) => (s.tabIndex = s.getAttribute('aria-checked') === 'true' ? 0 : -1));
      }
    }
  );
}
